import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';

function deepMerge(base, override) {
  const out = { ...base };
  for (const key of Object.keys(override)) {
    out[key] = (typeof base[key] === 'object' && typeof override[key] === 'object'
      && !Array.isArray(base[key]))
      ? deepMerge(base[key], override[key])
      : override[key];
  }
  return out;
}

function getStoredLanguage() {
  try {
    const profile = JSON.parse(localStorage.getItem('kairos_profile') || 'null');
    return profile?.languagePreference || 'en';
  } catch {
    return 'en';
  }
}

i18n.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export async function loadLanguage(lng) {
  if (!lng || lng === i18n.language) return i18n.language;
  if (i18n.hasResourceBundle(lng, 'translation')) {
    return i18n.changeLanguage(lng);
  }
  if (lng === 'af') {
    const [appMod, sharedMod] = await Promise.all([
      import('./locales/af.json'),
      import('./locales/af-shared.json'),
    ]);
    i18n.addResourceBundle('af', 'translation', deepMerge(sharedMod.default, appMod.default));
  } else if (lng === 'zu') {
    const zuMod = await import('./locales/zu.json');
    // isiZulu falls back to English for any missing keys
    i18n.addResourceBundle('zu', 'translation', deepMerge(en, zuMod.default));
  } else {
    return i18n.language;
  }
  return i18n.changeLanguage(lng);
}

// Kick off the stored language async; English UI renders immediately and swaps in
// once the bundle arrives. Errors here are non-fatal — fallback stays as English.
const stored = getStoredLanguage();
if (stored !== 'en') loadLanguage(stored).catch(() => {});

export default i18n;
